import React from 'react'
import { LeftSearchMenuPiece } from '../search/LeftSearchMenuPiece'
import { RadioButton } from '@deere/ux.uxframe-react'
import { useDispatch, useSelector } from 'react-redux'
import { setCRSSelection, setStatuses , setTitlePage} from '../redux/action/filterAction'
import { CRS_REQUEST_STATUS, CRS_CAMPAIGN_STATUS, CRS_SEARCH_CAMPAIGNS_TITLE_PAGE, CRS_SEARCH_DEFAULT_TITLE_PAGE } from '../utils/surveyLiterals'

export const RequestCampaignFilter = ({ setStatusSelected }) => {
    const crsSelection = useSelector(state => state.filter.crsSelection)
    const dispatch = useDispatch();

    const handleCRSTypeRadioButtonChange = event => {
        const code = event.target.id
        crsTypeSelection(code)
    }

    const crsTypeSelection = (code) => {
        if (code) {
            const newCrsSelection = crsSelection.map(item => {
                const temp = Object.assign({}, item)
                temp.selected = !temp.selected
                return temp
            })
            dispatch(setCRSSelection(newCrsSelection))
            setStatusSelected([])
            code === 'Request' ? updateStatuses(CRS_REQUEST_STATUS) :  updateStatuses(CRS_CAMPAIGN_STATUS)
            code === 'Request' ? dispatch(setTitlePage(CRS_SEARCH_DEFAULT_TITLE_PAGE)) :  dispatch(setTitlePage(CRS_SEARCH_CAMPAIGNS_TITLE_PAGE))
        }
    }

    const updateStatuses = (statuses) => {
        statuses.forEach(s => s.checked = false)
        dispatch(setStatuses([...statuses]))
    }


    return (
        <LeftSearchMenuPiece>
            <LeftSearchMenuPiece.Item id="request_campaign_filter" title="CRS Type">
                {crsSelection.map((t, index) => <RadioButton id={t.code} label={t.code} key={index} name='crsType' checked={t.selected} onChange={handleCRSTypeRadioButtonChange} />)}
            </LeftSearchMenuPiece.Item>
        </LeftSearchMenuPiece>
    )
}